import { Suspense, lazy } from "react";

const Revenue = lazy(() => import("./PlatformRevenue").then((m) => ({ default: m.PlatformRevenue })));
const Money = lazy(() => import("./MoneyTab").then((m) => ({ default: m.MoneyPage })));

// A tab of the Platform page: what came in and what goes out, in two
// sections of one page.
export const platformMoneyTab = {
  key: "money",
  label: "Subscriptions",
  path: "/platform/money",
  after: "users",
  component: (props) => (
    <Suspense fallback={null}>
      <Money {...props} />
    </Suspense>
  ),
};

// A tab of the Platform page: the revenue ledger.
export const platformRevenueTab = {
  key: "revenue",
  label: "Revenue",
  path: "/platform/revenue",
  after: "subscriptions",
  component: (props) => (
    <Suspense fallback={null}>
      <Revenue {...props} />
    </Suspense>
  ),
};
